/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Message } from '../models';
// @ts-ignore
import { Status } from '../models';
/**
 * StatusService - axios parameter creator
 * @export
 */
export const StatusServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Liefert eine Liste von Status
         * @summary Status Liste
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllStati: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/stati`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatusService - functional programming interface
 * @export
 */
export const StatusServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StatusServiceAxiosParamCreator(configuration)
    return {
        /**
         * Liefert eine Liste von Status
         * @summary Status Liste
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllStati(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Status>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllStati(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StatusService - factory interface
 * @export
 */
export const StatusServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StatusServiceFp(configuration)
    return {
        /**
         * Liefert eine Liste von Status
         * @summary Status Liste
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllStati(options?: any): AxiosPromise<Array<Status>> {
            return localVarFp.getAllStati(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StatusService - interface
 * @export
 * @interface StatusService
 */
export interface StatusServiceInterface {
    /**
     * Liefert eine Liste von Status
     * @summary Status Liste
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatusServiceInterface
     */
    getAllStati(options?: any): AxiosPromise<Array<Status>>;

}

/**
 * StatusService - object-oriented interface
 * @export
 * @class StatusService
 * @extends {BaseAPI}
 */
export class StatusService extends BaseAPI implements StatusServiceInterface {
    /**
     * Liefert eine Liste von Status
     * @summary Status Liste
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatusService
     */
    public getAllStati(options?: any) {
        return StatusServiceFp(this.configuration).getAllStati(options).then((request) => request(this.axios, this.basePath));
    }
}
